import React, {Component} from "react";
import {connect} from "react-redux";
import applogic from "../applogic.js";
import ModalLogin from "./ModalLogin.js";
import ModalReplies from "./ModalReplies.js";

class AppHeaderUser extends Component {
    render() {
        let login, user = this.props.user;
        if (!user) {
            login = (
                <div>
                    <button className="btn btn-link" data-toggle="modal" data-target="#modalLogin"
                            onClick={applogic.showLoginModal.bind(null, {reason: applogic.showLoginModal.messages.login})}>
                        Login
                    </button>
                    <ModalLogin/>
                </div>
            );
        } else {
            let notification;
            if (this.props.notification) {
                notification = (<span className="badge badge-danger">{this.props.notification}</span>);
            } else {
                notification = (<span className="badge badge-default">0</span>);
            }
            login =(
            <div className="dropdown">
                <a className="dropdown-toggle greeting" href="#" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="greeting">Hi {user.name || user.userID }! </span>{notification}
                </a>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a className="dropdown-item" href="#" data-toggle="modal" data-target="#modalReplies" onClick={applogic.getReplies}>Replies {notification}</a>
                    <div className="dropdown-divider"/>
                    <a className="dropdown-item" href="/" onClick={applogic.handleLogoutOnClick}>Logout</a>
                </div>
                <ModalLogin/>
                <ModalReplies/>
            </div>
            )
        }
        return login;
    }
}
let mapStateToProps = (state) => {
    return {
        user: state.user,
        notification: state.notification
    };
};
export default connect(mapStateToProps)(AppHeaderUser);


// WEBPACK FOOTER //
// ./src/componentsHeader/AppHeaderUser.js